var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                _vm._v("\n                Renters List\n            ")
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-3",
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.editReservee()
                        }
                      }
                    },
                    [_vm._v("Add")]
                  ),
                  _vm._v(" "),
                  !_vm.$store.state.model.reservation.group_link_id &&
                  _vm.do_not_show_price_on_checkout != 1 &&
                  !(
                    _vm.$store.state.model.reservation._type == "advance" &&
                    !_vm.$store.state.model.reservation.is_seasonal &&
                    _vm.no_priceing_checkouts == 1
                  )
                    ? [
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.ui__openModalByName({
                                  name: "dialog_rental_rates"
                                })
                              }
                            }
                          },
                          [_vm._v("See prices")]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { "three-line": "" } },
        [
          _c("v-divider", { staticClass: "m-0" }),
          _vm._v(" "),
          _vm.reservees.filter(function(r) {
            return r.full_name
          }).length === 0
            ? _c(
                "v-list-item",
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "w-100",
                      attrs: { dense: "", text: "", type: "info" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.editReservee()
                            }
                          }
                        },
                        [_vm._v("You can click here to add a renter.")]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(
            _vm.reservees.filter(function(r) {
              return r.full_name
            }),
            function(reservee) {
              return [
                _c(
                  "v-list-item",
                  { key: "list_item_" + reservee._id },
                  [
                    _c(
                      "v-list-item-avatar",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "grey lighten-1",
                            attrs: { dark: "" }
                          },
                          [
                            _vm._v(
                              "\n                        mdi-ski\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", {
                          domProps: { textContent: _vm._s(reservee.full_name) }
                        }),
                        _vm._v(" "),
                        _c("v-list-item-subtitle", {
                          domProps: {
                            textContent: _vm._s(_vm.reserveeSubtitle(reservee))
                          }
                        }),
                        _vm._v(" "),
                        _c("v-list-item-subtitle", {
                          domProps: {
                            textContent: _vm._s(_vm.reserveeSubtitle2(reservee))
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-action",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.editReservee(reservee)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "primary" } }, [
                              _vm._v("mdi-pencil")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.deleteReservee(reservee, false)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "error" } }, [
                              _vm._v("mdi-delete")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-divider", { key: "divider_" + reservee._id })
              ]
            }
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialogDelete,
            callback: function($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete"
          }
        },
        [
          _vm.currentEditReservee
            ? _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "text-h5" }, [
                    _vm._v(
                      "Are you sure you want to delete " +
                        _vm._s(_vm.currentEditReservee.full_name) +
                        "?\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogDelete = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: {
                            click: function($event) {
                              return _vm.deleteReservee(
                                _vm.currentEditReservee,
                                true
                              )
                            }
                          }
                        },
                        [_vm._v("OK")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }